var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-section page-header"},[_c('h2',{staticClass:"product-title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }